import { useEffect, useMemo, useState } from 'react';

// Which of a season's raster pieces actually exist. Each URL is decoded with
// an Image; a missing file comes back as the SPA's HTML (dev and production
// both fall through to index.html), fails to decode, and keeps its fallback.
// Results are shared across mounts so a route change never re-probes.
const known = new Map<string, boolean>();

export function useRasterArt(art: Record<string, string> | undefined): Record<string, string> {
  const [version, bump] = useState(0);

  useEffect(() => {
    if (!art) return;
    let alive = true;
    for (const url of Object.values(art)) {
      if (known.has(url)) continue;
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        known.set(url, img.naturalWidth > 0);
        if (alive) bump(n => n + 1);
      };
      img.onerror = () => {
        known.set(url, false);
      };
      img.src = url;
    }
    return () => {
      alive = false;
    };
  }, [art]);

  return useMemo(() => {
    const ready: Record<string, string> = {};
    if (art && version >= 0) {
      for (const [piece, url] of Object.entries(art)) if (known.get(url)) ready[piece] = url;
    }
    return ready;
  }, [art, version]);
}
